// extracted by mini-css-extract-plugin
export default {"component":"select__component___R8ijq","label":"select__label___9+6LP"};